import React from "react";

import TotalCosmeticPresenter from "./TotalCosmeticPresenter";

export default class extends React.Component {

  render() {
    return <TotalCosmeticPresenter />;
  }
}
